import React, { Component } from "react";
import "./App.css";
import { Grommet, grommet, Box, Header, Heading, Grid, Button } from "grommet";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";

import ATV from "./ATV";
import TVL from "./TVL";
import TVO from "./TVO";
import ROB from "./ROB";
import Render from "./Render";

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Grommet theme={grommet}>
          <Box fill="vertical" overflow="auto" align="center" flex="grow">
            <Header
              align="center"
              direction="row"
              flex={false}
              justify="center"
              gap="medium"
              fill="horizontal"
            >
              <Heading>Weerbericht</Heading>
            </Header>
            <Router>
              <Grid
                columns="small"
                margin="small"
                fill="horizontal"
                gap="medium"
              >
                <Link to={"/atv"}>
                  <Button label="ATV" />
                </Link>
              </Grid>
              <Switch>
                <Route exact path="/atv" component={ATV} />
                <Route exact path="/render" component={Render} />
              </Switch>
            </Router>
          </Box>
        </Grommet>
      </React.Fragment>
    );
  }
}

export default App;
